import AmountInput from "@components/AmountInput";
import FormikTextareaResizable from "@components/FormikTextareaResizable";
import {
  MAX_POST_DESCRIPTION,
  MIN_DONATION_AMOUNT,
} from "@validation/lengthConstants";
import { useTranslation } from "react-i18next";

const SendTipForm = () => {
  const { t } = useTranslation("labels");

  return (
    <>
      <AmountInput
        label="AMOUNT"
        rows={1}
        type="amount"
        usdPrice
        itemPrice={MIN_DONATION_AMOUNT}
      />
      <FormikTextareaResizable
        label={<>{t("MESSAGE")}</>}
        maxHeight={380}
        placeholder="ENTER_DESCRIPTION"
        wrapperClassName="mt-3"
        name="message"
        type="textarea"
        textLabel="DESCRIPTION"
        maxLength={MAX_POST_DESCRIPTION}
        isEmoji
      />
    </>
  );
};

export default SendTipForm;
